module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_bronze-9739902f96bbfe3b10a4831430788f6c.png";